<i18n>
{
	"en": {
		"add": "Added",
		"remove": "Removed",
		"vendor": "Owner",
		"name": "Name",
		"orgNo": "Organization Number",
		"vendorNumber": "Vendor Number",
		"countryCode": "Country Code",
		"postalCode": "Postal Code",
		"postalPlace": "Postal Place",
		"street": "Street"
	},
	"no": {
		"add": "Laget",
		"remove": "Slettet",
		"vendor": "Eier",
		"name": "Navn",
		"orgNo": "Foretaksnummer",
		"vendorNumber": "Leverandørnummer",
		"countryCode": "Landkode",
		"postalCode": "Postnummer",
		"postalPlace": "Poststed",
		"street": "Gate"
	}
}
</i18n>
<template>
	<t-vertical-panel>
		<div slot="header" class="details-header">
			<t-panel-header icon="undefined" :text="$t('vendor')"/>
			<div class="details-header-sub-label" v-text="$t(op)"/>
			<t-icon-button
				style="margin-right: 10px;"
				appearance="minimal"
				type="bp"
				icon="cross"
				iconSize="md"
				@click="$emit('close')"
			/>
		</div>
		<div class="content">
			<t-pane v-bind="paneOptions">
				<div class="content-data">
					<TLabeledValue
						:label="$t('name')"
						:value="data.name"
						labelMarginBottom="5px"
						style="grid-column: 1/3"
					/>
					<TLabeledValue
						:label="$t('vendorNumber')"
						:value="data.vendorNumber"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('orgNo')"
						:value="data.orgNo"
						labelMarginBottom="5px"
					/>

					<TLabeledValue
						:label="$t('street')"
						:value="data.street"
						labelMarginBottom="5px"
						style="grid-column: 1/3"
					/>
					<TLabeledValue
						:label="$t('postalCode')"
						:value="data.postalCode"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('postalPlace')"
						:value="data.postalPlace"
						labelMarginBottom="5px"
					/>
					<TLabeledValue
						:label="$t('countryCode')"
						:value="data.countryCode"
						labelMarginBottom="5px"
					/>
				</div>
			</t-pane>
		</div>
	</t-vertical-panel>
</template>

<script>
export default {
	name: 'Vendor',
	props: {
		data: Object,
		op: String
	},
	data() {
		return {
			paneOptions: {
				border: 'default',
				background: 'tint1',
				borderRadius: '5px',
				style: { padding: '5px', }
			},
		};
	}
};
</script>
<style lang="scss" scoped>
.content {
	margin: 10px;
}
.content-data {
	display: grid;
	grid-template-columns: repeat(2, minmax(150px, 1fr));
	column-gap: 20px;
	row-gap: 20px;
}
.details-header {
	height: 100%;
	display:flex;
	align-items: center;
	padding-left: 5px;
	.details-header-sub-label {
		flex: 1;
		color: #66788a;
		font-size: 14px;
	}
}
</style>